import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-5d366981")
const _hoisted_1 = { class: "p-d-flex p-jc-between p-ai-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "p-m-0" }, "Empresas Co-creadoras", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" No hay empresas todavía. ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Cargando... ")
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "ch-w100 ch-df" }
const _hoisted_10 = ["src"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_EditBrandDialog = _resolveComponent("EditBrandDialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DataTable, {
      value: _ctx.brands,
      paginator: false,
      dataKey: "id",
      rowHover: true,
      loading: _ctx.loading,
      paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
      globalFilterFields: ['name', 'state'],
      filters: _ctx.filters,
      "onUpdate:filters": _cache[0] || (_cache[0] = ($event: any) => (_ctx.filters = $event)),
      showGridlines: "",
      responsiveLayout: "scroll"
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", null, [
            _createVNode(_component_Button, {
              icon: "pi pi-plus-circle",
              label: "Agregar Empresa",
              class: "p-button-rounded p-button-text p-ml-1 p-button-success",
              onClick: _ctx.addNew
            }, null, 8, ["onClick"])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _hoisted_3
      ]),
      loading: _withCtx(() => [
        _hoisted_4
      ]),
      default: _withCtx(() => [
        _createVNode(_component_Column, {
          header: "Nombre",
          sortable: "",
          field: "name"
        }),
        _createVNode(_component_Column, {
          header: "No se muestra en (Paises)",
          sortable: "",
          field: "hiddenOnCountries"
        }, {
          body: _withCtx(({ data }) => [
            (data.hiddenOnCountries.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(data.hiddenOnCountries.map(_ctx.getCountryNameById).join(', ')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Certifica (Productos)",
          sortable: "",
          field: "products"
        }, {
          body: _withCtx(({ data }) => [
            (data.certifiesProducts.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(data.certifiesProducts.map(_ctx.getProductNameById).join(', ')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Cobrandea (Productos)",
          sortable: "",
          field: "products"
        }, {
          body: _withCtx(({ data }) => [
            (data.cobrandsProducts.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(data.cobrandsProducts.map(_ctx.getProductNameById).join(', ')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Se muestra en (Categorías)",
          sortable: "",
          field: "categories"
        }, {
          body: _withCtx(({ data }) => [
            (data.categories.length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(data.categories.map(_ctx.getCategoryNameById).join(', ')), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          header: "Logo",
          sortable: "",
          field: "logoUrl"
        }, {
          body: _withCtx(({ data }) => [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                class: "brand-logo",
                src: data.logoUrl,
                alt: ""
              }, null, 8, _hoisted_10)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_Column, {
          headerStyle: "width: 8rem; text-align: center",
          bodyStyle: "text-align: center; overflow: visible"
        }, {
          body: _withCtx(({ data }) => [
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-trash",
              onClick: ($event: any) => (_ctx.onDelete(data)),
              class: "p-mr-1"
            }, null, 8, ["onClick"]),
            _createVNode(_component_Button, {
              type: "button",
              icon: "pi pi-pencil",
              onClick: ($event: any) => (_ctx.onEdit(data))
            }, null, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["value", "loading", "filters"]),
    (_ctx.showEditDialog)
      ? (_openBlock(), _createBlock(_component_EditBrandDialog, {
          key: 0,
          brand: _ctx.editingBrand,
          show: _ctx.showEditDialog,
          products: _ctx.products,
          categories: _ctx.categories,
          onOnCancel: _ctx.onCancelEditDialog,
          onOnSave: _ctx.onSaveBrand,
          onLoading: _ctx.setLoadingValue
        }, null, 8, ["brand", "show", "products", "categories", "onOnCancel", "onOnSave", "onLoading"]))
      : _createCommentVNode("", true)
  ]))
}